import React, { useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from './ThemeContext';
import { AuthProvider } from '../../contexts/AuthContext';
import i18n from '../../shared/config/i18n';

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  const [i18nInitialized, setI18nInitialized] = useState(false);

  useEffect(() => {
    // 检查i18n是否已经初始化
    if (i18n.isInitialized) {
      // console.log('i18n already initialized');
      setI18nInitialized(true);
    } else {
      // console.log('Waiting for i18n to initialize...');
      // 等待i18n初始化完成
      i18n.on('initialized', () => {
        // console.log('i18n initialization event received');
        setI18nInitialized(true);
      });
      
      // 备用方案：如果事件没有触发，设置一个超时
      const timeout = setTimeout(() => {
        if (i18n.isInitialized) {
          // console.log('i18n initialized (timeout check)');
          setI18nInitialized(true);
        }
      }, 1000);
      
      return () => {
        clearTimeout(timeout);
        i18n.off('initialized');
      };
    }
  }, []);

  // 等待i18n初始化完成
  if (!i18nInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px'
      }}>
        正在初始化应用...
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 8,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
        },
      }}
    >
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <AuthProvider>
            {children}
          </AuthProvider>
        </ThemeProvider>
      </I18nextProvider>
    </ConfigProvider>
  );
};

export default AppProviders; 